<script>
const name = 'ten-avatar';
export default {
  name,
  props: {
    /**
     * 头像尺寸
     *
     * @member large | medium | small
     */
    size: {
      type: [Number, String],
      validator(val) {
        if (typeof val === 'string') {
          return ['large', 'medium', 'small'].includes(val);
        }
        return typeof val === 'number';
      },
    },
    /**
     * 设置头像的图标类型，参考 Icon 组件
     */
    icon: String,
    /**
     * 图片头像的资源地址
     */
    src: String,
    /**
     * 图片类头像加载失败的回调， 返回 false 会关闭组件默认的 fallback 行为
     */
    error: Function,
  },
  data() {
    return {
      isImageExist: true,
    };
  },
  computed: {
    avatarClass() {
      const { size, icon } = this;
      const classList = ['ten-avatar'];
      if (size && typeof size === 'string') {
        classList.push(`ten-avatar--${size}`);
      }
      if (icon) {
        classList.push('ten-avatar--icon');
      }

      return classList.join(' ');
    },
  },
  methods: {
    handleError() {
      const { error } = this;
      const errorFlag = error ? error() : undefined;
      if (errorFlag !== false) {
        this.isImageExist = false;
      }
    },
    renderAvatar() {
      const { icon, src, isImageExist } = this;
      if (isImageExist && src) {
        return <img
          src={src}
          onError={this.handleError}
        />;
      }
      if (icon) {
        return (<ten-icon icon={icon} />);
      }
      return this.$slots.default;
    },
  },
  render() {
    const { avatarClass, size, isImageExist, src } = this;
    let classNames = avatarClass;
    if (isImageExist && src) {
      const classArray = classNames.split(' ');
      classArray.push('ten-avatar--image');
      classNames = classArray.join(' ');
    }
    const sizeStyle = typeof size === 'number' ? {
      height: `${size}px`,
      width: `${size}px`,
      lineHeight: `${size}px`,
    } : {};
    return (
      <span class={ classNames } style={ sizeStyle }>
        {
          this.renderAvatar()
        }
      </span>
    );
  },
};
</script>
